import { toRaw, unref } from 'vue'
import { useNuxtApp } from '#app'
import type { Client, Rating } from '~/types/types'

export const clientsRepository = () => {
  const { $api } = useNuxtApp()

  return {
    async showById(id: string): Promise<Client> {
      const response = await $api<{ data: Client }>(`clients/${id}`)
      return response.data
    },

    async getClientRatings(
      id: string,
      filters: Record<string, any> = {},
      page: number = 1
    ): Promise<{ data: Rating[]; nextPage: number | null; appended_data: Object }> {
      // Unwrap the filters in case they are computed/reactive, then convert to raw object
      const rawFilters = toRaw(unref(filters))
      
      const response = await $api<{
        data: Rating[]
        meta: { current_page: number; last_page: number; appended_data: Object }
      }>(`clients/${id}/ratings`, {
        method: 'GET',
        params: { ...rawFilters, page },
      })

      const nextPage =
        response?.meta?.current_page && response?.meta?.current_page < response?.meta?.last_page
          ? response.meta.current_page + 1
          : null

      return {
        data: response.data,
        appended_data: response.appended_data ?? {},
        nextPage,
      }
    },
  }
}
